import { ColumnLabel, ColumnValue } from "./Columns";
import { Product } from "../../product";

export const ProductListEANColumn = {
  name: ColumnValue.EAN,
  label: ColumnLabel[ColumnValue.EAN],
  renderCell: (p: Product): string => p.ean,
};
